<header
	class="header"
	[ngClass]="{'m--no-background': (brandConfig$ | async)?.id?.toLowerCase() !== 'embrace'}"
>
	<section
		class="header__start"
		[ngClass]="{'m--embrace-logo-first': embraceLogoFirst}"
	>
		<ng-container *ngIf="brandLockup">
			<ng-container *ngIf="isAllstate; then contact; else whitelabel"></ng-container>
		</ng-container>

		<ng-container *ngIf="isClickableEmbraceLogo; then embraceLogoClickable; else embraceLogo"></ng-container>
	</section>
	<section class="header__end" *ngIf="!isAllstate; then contact; else whitelabel">
		<ng-container></ng-container>
	</section>
</header>

<ng-template #contact>
	<div class="header__contact">
		<p class="header__contact-text">
			Questions? We can help.
		</p>
		<p class="header__contact-number">
			{{ formattedPhoneNumber }}
		</p>
	</div>
	<a
		qeBaseButton
		href="tel:{{ dialablePhoneNumber }}"
		class="header__contact-button m--minimal"
		data-gtm="mobileHeaderPhoneButton"
	>
		Call Us
	</a>
</ng-template>

<ng-template #embraceLogo>
	<div>
		<img
			[src]="logoSrc"
			alt="Embrace Brand Logo that Links to Embrace Pet Insurance's Website"
			class="header__logo m--embrace"
			[ngClass]="{'m--first': embraceLogoFirst, 'm--second': !embraceLogoFirst, 'm--allstate': isAllstate}"
			data-quat="value_headerEmbraceImage"
		>
	</div>
</ng-template>

<ng-template #embraceLogoClickable>
	<epi-link
		*ngIf="isClickableEmbraceLogo"
		[to]="whitelabelLogoTarget"
		data-quat="action_headerEmbraceWebsiteLink"
	>
		<img
			[src]="logoSrc"
			alt="Embrace Brand Logo that Links to Embrace Pet Insurance's Website"
			class="header__logo m--embrace"
			data-quat="value_headerEmbraceImage"
		>
	</epi-link>
</ng-template>

<ng-template #partnerLogo>
	<img
		[src]="(whitelabelLogoSrc$ | async) || ''"
		alt="Brand Logo Linking to Brand's Website"
		class="header__logo m--whitelabel"
		[ngClass]="embraceLogoFirst ? 'm--second' : 'm--first'"
		data-quat="value_headerWhitelabelImage"
	>
</ng-template>

<ng-template #whitelabel>
	<epi-link
		*ngIf="isClickablePartnerLogo"
		[to]="whitelabelLogoTarget"
		data-quat="action_headerWhitelabelWebsiteLink"
	>
		<ng-container *ngTemplateOutlet="partnerLogo"></ng-container>
	</epi-link>
	<div *ngIf="!isClickablePartnerLogo" [ngClass]="{'m--allstate': isAllstate}">
		<ng-container *ngTemplateOutlet="partnerLogo"></ng-container>
	</div>
</ng-template>

